import { useState } from "react";
import { tinaField, useTina } from "tinacms/dist/react";
import bookingContent from "../../../content/pages/booking.json";
import { PageDocument } from "../../../tina/__generated__/types";
import { PageSeo } from "../../navigation/PageSeo";

const initialData = { page: bookingContent };
const variables = { relativePath: "booking.json" };

export const Booking = () => {
  const [isBookingLoaded, setIsBookingLoaded] = useState(false);
  const { data } = useTina({ query: PageDocument, variables, data: initialData });
  const booking = data.page;

  return (
    <main className="bg-light-ui px-6 py-14 text-slate-900 dark:bg-dark-purple-ui dark:text-white">
      <PageSeo pathname="/booking" seo={booking.seo} />
      <section className="mx-auto max-w-5xl">
        <header className="mb-8 page-hero-dots">
          <p
            className="mb-2 text-sm font-semibold uppercase tracking-wider text-primary"
            data-tina-field={tinaField(booking, "eyebrow")}
          >
            {booking.eyebrow}
          </p>
          <h1
            className="text-4xl font-semibold text-[#33005b] dark:text-violet-100"
            data-tina-field={tinaField(booking, "heading")}
          >
            {booking.heading}
          </h1>
          <p
            className="mt-3 leading-7 text-slate-600 dark:text-slate-300"
            data-tina-field={tinaField(booking, "description")}
          >
            {booking.description}
          </p>
        </header>
        <div
          className="relative min-h-[560px] overflow-hidden rounded-lg bg-white shadow-sm ring-1 ring-black/10 dark:bg-[#24103a] dark:ring-white/10"
          aria-busy={!isBookingLoaded}
        >
          {!isBookingLoaded && (
            <div className="absolute inset-0 z-10 animate-pulse bg-white p-6 dark:bg-[#24103a]" role="status">
              <span className="sr-only">Loading booking calendar</span>
              <div className="mb-6 h-8 w-1/3 rounded bg-slate-200 dark:bg-white/10" />
              <div className="mb-4 h-5 w-1/2 rounded bg-slate-200 dark:bg-white/10" />
              <div className="mb-6 grid grid-cols-7 gap-3">
                {Array.from({ length: 7 }, (_, index) => (
                  <div key={`day-${index}`} className="h-4 rounded bg-slate-200 dark:bg-white/10" />
                ))}
              </div>
              <div className="grid grid-cols-7 gap-3">
                {Array.from({ length: 35 }, (_, index) => (
                  <div key={`date-${index}`} className="aspect-square rounded bg-slate-100 dark:bg-white/5" />
                ))}
              </div>
            </div>
          )}
          <iframe
            src={booking.widgetUrl ?? undefined}
            className="block w-full"
            style={{ border: "none", height: "560px" }}
            title="Square Appointments"
            onLoad={() => setIsBookingLoaded(true)}
          />
        </div>
        <a
          target="_top"
          className="bg-primary"
          style={{
            border: "none",
            color: "white",
            height: 40,
            textTransform: "uppercase",
            fontFamily: "'Square Market', sans-serif",
            letterSpacing: "1px",
            lineHeight: "38px",
            padding: "0px 28px",
            marginTop: "20px",
            borderRadius: 8,
            fontWeight: 500,
            fontSize: 14,
            cursor: "pointer",
            display: "inline-block",
          }}
          href={booking.ctaHref ?? undefined}
          rel="nofollow"
          data-tina-field={tinaField(booking, "ctaLabel")}
        >
          {booking.ctaLabel}
        </a>
      </section>
    </main>
  );
};

export default Booking;
